export enum PensionSubmissionStatus {
  Due = 'Due',
  Pending = 'Pending',
  Completed = 'Completed',
  Failed = 'Failed',
  AuthReq = 'AuthReq'
}

export const PensionSubmissionStatusLabels: Record<PensionSubmissionStatus, string> = {
  [PensionSubmissionStatus.Due]: 'Due',
  [PensionSubmissionStatus.Pending]: 'Pending',
  [PensionSubmissionStatus.Completed]: 'Completed',
  [PensionSubmissionStatus.Failed]: 'Failed',
  [PensionSubmissionStatus.AuthReq]: 'Authorization Required'
};

export function getStatusLabel(status: PensionSubmissionStatus): string {
  return PensionSubmissionStatusLabels[status];
}
